module.exports = __webpack_public_path__ + "img/week.41d62e4a.svg";